import { getData } from 'conversations-async-data/async-data/operators/getters';
import { createSelector } from 'reselect';
import { getInitialThreadViewAsyncData } from './getInitialThreadViewAsyncData';
export const getInitialThreadViewState = createSelector([getInitialThreadViewAsyncData], getData);